const readBidId = (readField, bid) => String(readField('_id', bid));
const readBidUpdatedAt = (readField, bid) => readField('updatedAt', bid);
export const shouldKeepExistingBid = (existingUpdatedAt, incomingUpdatedAt) => {
    if (existingUpdatedAt != null && incomingUpdatedAt != null) {
        return new Date(existingUpdatedAt) > new Date(incomingUpdatedAt);
    }
    return false;
};
export const mergeBidByTimestamp = (existing, incoming, { readField }) => {
    if (!existing) {
        return incoming;
    }
    const existingUpdatedAt = readBidUpdatedAt(readField, existing);
    const incomingUpdatedAt = readBidUpdatedAt(readField, incoming);
    if (shouldKeepExistingBid(existingUpdatedAt, incomingUpdatedAt)) {
        return existing;
    }
    return incoming;
};
export const mergeBidsByTimestamp = (existing = [], incoming, { readField }) => {
    const existingById = new Map(existing.map((bid) => [readBidId(readField, bid), bid]));
    return incoming.map((incomingBid) => {
        const existingBid = existingById.get(readBidId(readField, incomingBid));
        return mergeBidByTimestamp(existingBid, incomingBid, { readField });
    });
};
